import '../../components/FAQ/FAQ.css'
import Faq_Component from '../../components/FAQ/Faq_Component';
import Header from "../../components/Header/Header";
import FaqNav from "../../components/FAQ/FaqNav";
import Footer from "../../components/Footer/Footer";
import { useEffect, useState } from "react";
import { fetchAPI } from "../../services/api";
import NoResultsComponent from '../../components/NoResults/NoResult';
import Loader from '../../components/Loader/Loader';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/Languagecontext';

export default function Faq() {
  const { Globals, languages, setLanguages } = useLanguage();
  const [data, setData] = useState([]);

  const location = useLocation();
  let parentName = location.state?.parentName;
  const [NavLinkState, setNav] = useState ({
    FirstNavbar:"",
    SecondNavbar:"FAQ",
    Title:Globals.FAQ_DROPDOWN.FAQ,
    ParentTab: parentName,
  });

  const [contentDataStatus, setContentDataStatus] = useState(null)

  useEffect(() => {
    if(parentName === 'admin' || parentName === "internal_dashboard" || parentName === "dashboard") {
      parentName = "Dashboard"
    } else if (parentName === "requests") {
      parentName = "Requests"
    } else if (parentName === "auditTrails") {
      parentName = "Audit Trails"
    } else if (parentName === "internal_management") {
      parentName = "Internal Management"
    } else {
      parentName === 'proposals' ? parentName = "My Proposals" : parentName = "All Proposals";
    }
    setNav(nav => ({
      ...nav,
      FirstNavbar: parentName
    }));
  }, [])

/*   useEffect(() => {
    const getData = async () => {
      try {
        const result = await fetchAPI(Globals.ENDPOINT.FAQ_PAGE_API);
        setData(result?.content);
        setContentDataStatus(result.status);
      } catch (error) {
        setContentDataStatus("Error");
        console.error('Error in App component:', error);
      } };
      getData();
    }, []); */
  const getData = async () => {
    try {
      const result = await fetchAPI(Globals.ENDPOINT.FAQ_PAGE_API);
      setData(result?.content);
      setContentDataStatus(result.status);
    } catch (error) {
      setContentDataStatus("Error");
      console.error('Error in App component:', error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getData();
  }, [languages])

  const NavLinkData = { FirstNavbar: Globals.PRODUCER.DASHBOARD, SecondNavbar: Globals.FAQ_DROPDOWN.FAQ, Title: Globals.FAQ_DROPDOWN.FAQ }

  return (
    <div className="Background-Page">
      <Header route="FAQ" />
      <div className="Main">
        <FaqNav props={NavLinkState} />
        {data.length ? <>
          <div className="Faq_Comp">
            <Faq_Component data={data} />

          </div></> :
          contentDataStatus && contentDataStatus?.length > 0 ? <>
            <NoResultsComponent data={{ message: Globals.NO_DATA, img: Globals.NO_DATA_FOUND_IMG }} />
          </> : <div className="NoResultsComponent" style={{ height: "100vh" }}>
            <Loader height={50} width={50} component={"Faq"} />
          </div>
        }
      </div>
      <Footer />
    </div>
  );
}
